// Translations for the SNMP monitoring module + VPN/SNMP settings section.
export const en = {
  "Monitoring SNMP": "SNMP Monitoring",
  "Urządzenia": "Devices", "Podgląd na żywo": "Live view", "Trapy": "Traps",
  "Dodaj urządzenie": "Add device", "Zapisano urządzenie": "Device saved",
  "Nowe urządzenie": "New device", "Edycja urządzenia": "Edit device",
  "Nazwa (np. OLT Rynek)": "Name (e.g. OLT Market)", "Adres IP / host": "IP address / host",
  "Producent": "Manufacturer", "Port SNMP": "SNMP port", "Wersja SNMP": "SNMP version",
  "Community": "Community", "(ustawione)": "(set)", "Użytkownik v3": "v3 user",
  "Klucz Auth": "Auth key", "Klucz Priv": "Priv key",
  "OID liczby ONU": "ONU count OID", "OID Rx ONU": "ONU Rx OID", "Dzielnik Rx": "Rx divisor",
  "OID-y PON/ONU zależą od modelu i firmware — zweryfikuj.": "PON/ONU OIDs depend on model and firmware — verify.",
  "Aktywne (odpytywanie automatyczne)": "Active (automatic polling)",
  "Podaj nazwę i adres IP": "Provide a name and IP address",
  "Usunąć to urządzenie SNMP?": "Delete this SNMP device?", "Usunięto": "Deleted",
  "Odpytaj teraz": "Poll now", "Odpytano urządzenie": "Device polled",
  "Urządzenie nie odpowiada": "Device not responding",
  "Brak urządzeń. Dodaj pierwsze urządzenie SNMP.": "No devices. Add your first SNMP device.",
  "Podgląd": "View", "online": "online", "offline": "offline", "unknown": "unknown",
  "— wybierz urządzenie —": "— select a device —",
  "Auto-odświeżanie co": "Auto-refresh every", "konfigurowalne w Ustawieniach": "configurable in Settings",
  "Wybierz urządzenie, aby zobaczyć metryki.": "Select a device to view metrics.",
  "Brak danych — kliknij „Odpytaj teraz\".": "No data — click \"Poll now\".",
  "Czas pracy": "Uptime", "ONU online": "ONUs online", "Porty PON": "PON ports",
  "Poziomy Rx ONU [dBm]": "ONU Rx levels [dBm]", "Ruch na portach": "Port traffic",
  "Pobieranie": "Download", "Wysyłanie": "Upload", "Brak danych o portach": "No port data",
  "Prędkość": "Speed",
  "Ostatnie odebrane trapy (UDP)": "Recent received traps (UDP)",
  "Brak odebranych trapów.": "No traps received.",
  // Settings — network / VPN
  "Sieć i dostęp (SNMP / VPN)": "Network & access (SNMP / VPN)",
  "Interwał odpytywania SNMP [s]": "SNMP polling interval [s]",
  "Port odbioru trapów (UDP)": "Trap listener port (UDP)",
  "Odświeżanie podglądu na żywo [s]": "Live view refresh [s]",
  "Włącz konfigurację VPN": "Enable VPN configuration",
  "Typ VPN": "VPN type", "Host VPN": "VPN host", "Port VPN": "VPN port",
  "Klucz / certyfikat VPN": "VPN key / certificate",
  "Parametry VPN służą do dokumentacji dostępu do urządzeń w sieci klienta. Tunel zestawiany jest po stronie systemu operacyjnego serwera.":
    "VPN parameters document access to devices in the client network. The tunnel is established at the server OS level.",
  "Hasło SNMP": "SNMP password", "Login do urządzenia": "Device login",
  "Hasło do urządzenia (dostęp)": "Device password (access)",
  "VLAN ID (opcjonalnie)": "VLAN ID (optional)",
  "Tryb serwisowy (ignoruj alarmy)": "Maintenance mode (ignore alarms)",
  "Serwis": "Maint.", "Poświadczenia SNMPv3 (uwierzytelnianie + szyfrowanie)": "SNMPv3 credentials (authentication + encryption)",
  "Dostęp do urządzenia (dokumentacja) i sieć": "Device access (documentation) & network",
  "Próg zgłoszenia offline (liczba nieudanych odpytań)": "Offline ticket threshold (failed polls)",
  "Zgłoszenie awarii powstaje dopiero po tylu kolejnych nieudanych odpytaniach — chroni przed fałszywym alarmem gdy urządzenie zostanie chwilowo wyłączone.":
    "A fault ticket is only created after this many consecutive failed polls — protects against false alarms when a device is briefly powered off.",
  "Bezpośrednio (ta sama podsieć — bez VPN)": "Direct (same subnet — no VPN)",
  "VLAN — interfejs wirtualny na karcie sieciowej": "VLAN — virtual interface on the NIC",
  "VLAN ID (globalny)": "VLAN ID (global)", "Interfejs sieciowy (NIC)": "Network interface (NIC)",
  "Zastosuj VLAN na serwerze": "Apply VLAN on server",
  "Utworzono interfejs VLAN": "VLAN interface created", "Nie udało się utworzyć VLAN": "Failed to create VLAN",
  "Tworzenie VLAN wymaga uprawnień root na serwerze VPS i nie zadziała w środowisku podglądu.":
    "Creating a VLAN requires root privileges on the VPS server and will not work in the preview environment.",
  "Podaj VLAN ID": "Provide a VLAN ID",
  "Lokalizacja na mapie (dziedziczona z OLT lub ręczna)": "Map location (inherited from OLT or manual)",
  "— powiąż z OLT (dziedziczy lokalizację) —": "— link to OLT (inherits location) —",
  "Szerokość (lat)": "Latitude (lat)", "Długość (lng)": "Longitude (lng)",
  "Ostatnie odpytanie": "Last poll",
  "Wskaż na mapie": "Pick on map",
  "Kliknij na mapie, aby ustawić lokalizację urządzenia": "Click on the map to set the device location",
  "ID / indeks ONU (SNMP)": "ONU ID / index (SNMP)",
  "Klienci dotknięci (SNMP)": "Affected clients (SNMP)",
  "S/N ONU": "ONU S/N", "MAC ONU": "ONU MAC",
  "OID S/N ONU": "ONU S/N OID", "OID MAC ONU": "ONU MAC OID",
  "Przypisz ONU z OLT (SNMP)": "Assign ONU from OLT (SNMP)",
  "— wybierz ONU —": "— select ONU —",
  "Brak wykrytych ONU (odpytaj OLT w module SNMP)": "No ONUs discovered (poll the OLT in the SNMP module)",
  "Wybierz OLT i port PON powyżej. Lista pochodzi z ostatniego odpytania SNMP i uzupełnia ID/S/N/MAC ONU klienta.":
    "Select the OLT and PON port above. The list comes from the last SNMP poll and fills the client's ONU ID/S/N/MAC.",
};

export const de = {
  "Monitoring SNMP": "SNMP-Überwachung",
  "Urządzenia": "Geräte", "Podgląd na żywo": "Live-Ansicht", "Trapy": "Traps",
  "Dodaj urządzenie": "Gerät hinzufügen", "Zapisano urządzenie": "Gerät gespeichert",
  "Nowe urządzenie": "Neues Gerät", "Edycja urządzenia": "Gerät bearbeiten",
  "Nazwa (np. OLT Rynek)": "Name (z. B. OLT Markt)", "Adres IP / host": "IP-Adresse / Host",
  "Producent": "Hersteller", "Port SNMP": "SNMP-Port", "Wersja SNMP": "SNMP-Version",
  "Community": "Community", "(ustawione)": "(gesetzt)", "Użytkownik v3": "v3-Benutzer",
  "Klucz Auth": "Auth-Schlüssel", "Klucz Priv": "Priv-Schlüssel",
  "OID liczby ONU": "ONU-Anzahl OID", "OID Rx ONU": "ONU-Rx OID", "Dzielnik Rx": "Rx-Teiler",
  "OID-y PON/ONU zależą od modelu i firmware — zweryfikuj.": "PON/ONU-OIDs hängen von Modell und Firmware ab — überprüfen.",
  "Aktywne (odpytywanie automatyczne)": "Aktiv (automatische Abfrage)",
  "Podaj nazwę i adres IP": "Name und IP-Adresse angeben",
  "Usunąć to urządzenie SNMP?": "Dieses SNMP-Gerät löschen?", "Usunięto": "Gelöscht",
  "Odpytaj teraz": "Jetzt abfragen", "Odpytano urządzenie": "Gerät abgefragt",
  "Urządzenie nie odpowiada": "Gerät antwortet nicht",
  "Brak urządzeń. Dodaj pierwsze urządzenie SNMP.": "Keine Geräte. Fügen Sie Ihr erstes SNMP-Gerät hinzu.",
  "Podgląd": "Ansicht", "online": "online", "offline": "offline", "unknown": "unbekannt",
  "— wybierz urządzenie —": "— Gerät auswählen —",
  "Auto-odświeżanie co": "Auto-Aktualisierung alle", "konfigurowalne w Ustawieniach": "konfigurierbar in Einstellungen",
  "Wybierz urządzenie, aby zobaczyć metryki.": "Wählen Sie ein Gerät, um Metriken zu sehen.",
  "Brak danych — kliknij „Odpytaj teraz\".": "Keine Daten — „Jetzt abfragen“ klicken.",
  "Czas pracy": "Betriebszeit", "ONU online": "ONUs online", "Porty PON": "PON-Ports",
  "Poziomy Rx ONU [dBm]": "ONU-Rx-Pegel [dBm]", "Ruch na portach": "Port-Verkehr",
  "Pobieranie": "Download", "Wysyłanie": "Upload", "Brak danych o portach": "Keine Port-Daten",
  "Prędkość": "Geschwindigkeit",
  "Ostatnie odebrane trapy (UDP)": "Zuletzt empfangene Traps (UDP)",
  "Brak odebranych trapów.": "Keine Traps empfangen.",
  "Sieć i dostęp (SNMP / VPN)": "Netzwerk & Zugriff (SNMP / VPN)",
  "Interwał odpytywania SNMP [s]": "SNMP-Abfrageintervall [s]",
  "Port odbioru trapów (UDP)": "Trap-Empfangsport (UDP)",
  "Odświeżanie podglądu na żywo [s]": "Live-Ansicht-Aktualisierung [s]",
  "Włącz konfigurację VPN": "VPN-Konfiguration aktivieren",
  "Typ VPN": "VPN-Typ", "Host VPN": "VPN-Host", "Port VPN": "VPN-Port",
  "Klucz / certyfikat VPN": "VPN-Schlüssel / Zertifikat",
  "Parametry VPN służą do dokumentacji dostępu do urządzeń w sieci klienta. Tunel zestawiany jest po stronie systemu operacyjnego serwera.":
    "Die VPN-Parameter dokumentieren den Zugriff auf Geräte im Kundennetz. Der Tunnel wird auf Betriebssystemebene des Servers aufgebaut.",
  "Hasło SNMP": "SNMP-Passwort", "Login do urządzenia": "Geräte-Login",
  "Hasło do urządzenia (dostęp)": "Gerätepasswort (Zugriff)",
  "VLAN ID (opcjonalnie)": "VLAN-ID (optional)",
  "Tryb serwisowy (ignoruj alarmy)": "Wartungsmodus (Alarme ignorieren)",
  "Serwis": "Wartung", "Poświadczenia SNMPv3 (uwierzytelnianie + szyfrowanie)": "SNMPv3-Anmeldedaten (Authentifizierung + Verschlüsselung)",
  "Dostęp do urządzenia (dokumentacja) i sieć": "Gerätezugriff (Dokumentation) & Netzwerk",
  "Próg zgłoszenia offline (liczba nieudanych odpytań)": "Offline-Ticketschwelle (fehlgeschlagene Abfragen)",
  "Zgłoszenie awarii powstaje dopiero po tylu kolejnych nieudanych odpytaniach — chroni przed fałszywym alarmem gdy urządzenie zostanie chwilowo wyłączone.":
    "Ein Störungsticket wird erst nach so vielen aufeinanderfolgenden fehlgeschlagenen Abfragen erstellt — schützt vor Fehlalarmen, wenn ein Gerät kurz ausgeschaltet wird.",
  "Bezpośrednio (ta sama podsieć — bez VPN)": "Direkt (gleiches Subnetz — ohne VPN)",
  "VLAN — interfejs wirtualny na karcie sieciowej": "VLAN — virtuelle Schnittstelle an der Netzwerkkarte",
  "VLAN ID (globalny)": "VLAN-ID (global)", "Interfejs sieciowy (NIC)": "Netzwerkschnittstelle (NIC)",
  "Zastosuj VLAN na serwerze": "VLAN auf Server anwenden",
  "Utworzono interfejs VLAN": "VLAN-Schnittstelle erstellt", "Nie udało się utworzyć VLAN": "VLAN konnte nicht erstellt werden",
  "Tworzenie VLAN wymaga uprawnień root na serwerze VPS i nie zadziała w środowisku podglądu.":
    "Das Erstellen eines VLANs erfordert Root-Rechte auf dem VPS-Server und funktioniert nicht in der Vorschauumgebung.",
  "Podaj VLAN ID": "VLAN-ID angeben",
  "Lokalizacja na mapie (dziedziczona z OLT lub ręczna)": "Kartenstandort (vom OLT geerbt oder manuell)",
  "— powiąż z OLT (dziedziczy lokalizację) —": "— mit OLT verknüpfen (erbt Standort) —",
  "Szerokość (lat)": "Breite (lat)", "Długość (lng)": "Länge (lng)",
  "Ostatnie odpytanie": "Letzte Abfrage",
  "Wskaż na mapie": "Auf Karte wählen",
  "Kliknij na mapie, aby ustawić lokalizację urządzenia": "Auf die Karte klicken, um den Gerätestandort festzulegen",
  "ID / indeks ONU (SNMP)": "ONU-ID / Index (SNMP)",
  "Klienci dotknięci (SNMP)": "Betroffene Kunden (SNMP)",
  "S/N ONU": "ONU-S/N", "MAC ONU": "ONU-MAC",
  "OID S/N ONU": "ONU-S/N-OID", "OID MAC ONU": "ONU-MAC-OID",
  "Przypisz ONU z OLT (SNMP)": "ONU vom OLT zuweisen (SNMP)",
  "— wybierz ONU —": "— ONU wählen —",
  "Brak wykrytych ONU (odpytaj OLT w module SNMP)": "Keine ONUs erkannt (OLT im SNMP-Modul abfragen)",
  "Wybierz OLT i port PON powyżej. Lista pochodzi z ostatniego odpytania SNMP i uzupełnia ID/S/N/MAC ONU klienta.":
    "Wählen Sie oben OLT und PON-Port. Die Liste stammt aus der letzten SNMP-Abfrage und füllt ONU-ID/S/N/MAC des Kunden.",
};

export const uk = {
  "Monitoring SNMP": "Моніторинг SNMP",
  "Urządzenia": "Пристрої", "Podgląd na żywo": "Перегляд наживо", "Trapy": "Трапи",
  "Dodaj urządzenie": "Додати пристрій", "Zapisano urządzenie": "Пристрій збережено",
  "Nowe urządzenie": "Новий пристрій", "Edycja urządzenia": "Редагування пристрою",
  "Nazwa (np. OLT Rynek)": "Назва (напр. OLT Ринок)", "Adres IP / host": "IP-адреса / хост",
  "Producent": "Виробник", "Port SNMP": "Порт SNMP", "Wersja SNMP": "Версія SNMP",
  "Community": "Community", "(ustawione)": "(встановлено)", "Użytkownik v3": "Користувач v3",
  "Klucz Auth": "Ключ Auth", "Klucz Priv": "Ключ Priv",
  "OID liczby ONU": "OID кількості ONU", "OID Rx ONU": "OID Rx ONU", "Dzielnik Rx": "Дільник Rx",
  "OID-y PON/ONU zależą od modelu i firmware — zweryfikuj.": "OID PON/ONU залежать від моделі та прошивки — перевірте.",
  "Aktywne (odpytywanie automatyczne)": "Активний (автоматичне опитування)",
  "Podaj nazwę i adres IP": "Вкажіть назву та IP-адресу",
  "Usunąć to urządzenie SNMP?": "Видалити цей пристрій SNMP?", "Usunięto": "Видалено",
  "Odpytaj teraz": "Опитати зараз", "Odpytano urządzenie": "Пристрій опитано",
  "Urządzenie nie odpowiada": "Пристрій не відповідає",
  "Brak urządzeń. Dodaj pierwsze urządzenie SNMP.": "Немає пристроїв. Додайте перший пристрій SNMP.",
  "Podgląd": "Перегляд", "online": "онлайн", "offline": "офлайн", "unknown": "невідомо",
  "— wybierz urządzenie —": "— виберіть пристрій —",
  "Auto-odświeżanie co": "Автооновлення кожні", "konfigurowalne w Ustawieniach": "налаштовується в Налаштуваннях",
  "Wybierz urządzenie, aby zobaczyć metryki.": "Виберіть пристрій, щоб побачити метрики.",
  "Brak danych — kliknij „Odpytaj teraz\".": "Немає даних — натисніть «Опитати зараз».",
  "Czas pracy": "Час роботи", "ONU online": "ONU онлайн", "Porty PON": "Порти PON",
  "Poziomy Rx ONU [dBm]": "Рівні Rx ONU [dBm]", "Ruch na portach": "Трафік на портах",
  "Pobieranie": "Завантаження", "Wysyłanie": "Відвантаження", "Brak danych o portach": "Немає даних про порти",
  "Prędkość": "Швидкість",
  "Ostatnie odebrane trapy (UDP)": "Останні отримані трапи (UDP)",
  "Brak odebranych trapów.": "Трапів не отримано.",
  "Sieć i dostęp (SNMP / VPN)": "Мережа та доступ (SNMP / VPN)",
  "Interwał odpytywania SNMP [s]": "Інтервал опитування SNMP [с]",
  "Port odbioru trapów (UDP)": "Порт прийому трапів (UDP)",
  "Odświeżanie podglądu na żywo [s]": "Оновлення перегляду наживо [с]",
  "Włącz konfigurację VPN": "Увімкнути конфігурацію VPN",
  "Typ VPN": "Тип VPN", "Host VPN": "Хост VPN", "Port VPN": "Порт VPN",
  "Klucz / certyfikat VPN": "Ключ / сертифікат VPN",
  "Parametry VPN służą do dokumentacji dostępu do urządzeń w sieci klienta. Tunel zestawiany jest po stronie systemu operacyjnego serwera.":
    "Параметри VPN документують доступ до пристроїв у мережі клієнта. Тунель встановлюється на рівні ОС сервера.",
  "Hasło SNMP": "Пароль SNMP", "Login do urządzenia": "Логін пристрою",
  "Hasło do urządzenia (dostęp)": "Пароль пристрою (доступ)",
  "VLAN ID (opcjonalnie)": "VLAN ID (необов'язково)",
  "Tryb serwisowy (ignoruj alarmy)": "Сервісний режим (ігнорувати сповіщення)",
  "Serwis": "Сервіс", "Poświadczenia SNMPv3 (uwierzytelnianie + szyfrowanie)": "Облікові дані SNMPv3 (автентифікація + шифрування)",
  "Dostęp do urządzenia (dokumentacja) i sieć": "Доступ до пристрою (документація) та мережа",
  "Próg zgłoszenia offline (liczba nieudanych odpytań)": "Поріг звернення offline (невдалі опитування)",
  "Zgłoszenie awarii powstaje dopiero po tylu kolejnych nieudanych odpytaniach — chroni przed fałszywym alarmem gdy urządzenie zostanie chwilowo wyłączone.":
    "Звернення про аварію створюється лише після такої кількості невдалих опитувань поспіль — захищає від хибних спрацювань, коли пристрій ненадовго вимкнено.",
  "Bezpośrednio (ta sama podsieć — bez VPN)": "Напряму (та сама підмережа — без VPN)",
  "VLAN — interfejs wirtualny na karcie sieciowej": "VLAN — віртуальний інтерфейс на мережевій карті",
  "VLAN ID (globalny)": "VLAN ID (глобальний)", "Interfejs sieciowy (NIC)": "Мережевий інтерфейс (NIC)",
  "Zastosuj VLAN na serwerze": "Застосувати VLAN на сервері",
  "Utworzono interfejs VLAN": "Інтерфейс VLAN створено", "Nie udało się utworzyć VLAN": "Не вдалося створити VLAN",
  "Tworzenie VLAN wymaga uprawnień root na serwerze VPS i nie zadziała w środowisku podglądu.":
    "Створення VLAN потребує прав root на сервері VPS і не працюватиме в середовищі попереднього перегляду.",
  "Podaj VLAN ID": "Вкажіть VLAN ID",
  "Lokalizacja na mapie (dziedziczona z OLT lub ręczna)": "Розташування на карті (успадковано з OLT або вручну)",
  "— powiąż z OLT (dziedziczy lokalizację) —": "— прив'язати до OLT (успадковує розташування) —",
  "Szerokość (lat)": "Широта (lat)", "Długość (lng)": "Довгота (lng)",
  "Ostatnie odpytanie": "Останнє опитування",
  "Wskaż na mapie": "Вказати на карті",
  "Kliknij na mapie, aby ustawić lokalizację urządzenia": "Клацніть на карті, щоб встановити розташування пристрою",
  "ID / indeks ONU (SNMP)": "ID / індекс ONU (SNMP)",
  "Klienci dotknięci (SNMP)": "Задіяні клієнти (SNMP)",
  "S/N ONU": "S/N ONU", "MAC ONU": "MAC ONU",
  "OID S/N ONU": "OID S/N ONU", "OID MAC ONU": "OID MAC ONU",
  "Przypisz ONU z OLT (SNMP)": "Призначити ONU з OLT (SNMP)",
  "— wybierz ONU —": "— виберіть ONU —",
  "Brak wykrytych ONU (odpytaj OLT w module SNMP)": "ONU не виявлено (опитайте OLT у модулі SNMP)",
  "Wybierz OLT i port PON powyżej. Lista pochodzi z ostatniego odpytania SNMP i uzupełnia ID/S/N/MAC ONU klienta.":
    "Виберіть OLT і порт PON вище. Список береться з останнього опитування SNMP і заповнює ID/S/N/MAC ONU клієнта.",
};
